import React from "react";
import styled from "styled-components";
import { Flex } from "../../../../../Flex";
import { Span } from "../../../../../Span";
import { Meter } from "../../../../../../types/Meter";
import { mediaQueries } from "../../../../../../theme";
import { LabelValuePair } from "../../../../../LabelValuePair";

interface Props {
  idPrefix: string;
  index: number;
  meter: Meter;
}

const MeterDividerLine = styled(Flex)`
  display: none;

  ${mediaQueries.largeDevice} {
    display: flex;
    border-top: 1px solid;
    border-color: ${({ theme }) => theme.colors.neutrals.ln30};
    margin-top: ${({ theme }) => `${theme.space[3]}px`};
    margin-bottom: ${({ theme }) => `${theme.space[3]}px`};
  }
`;

export const OrderDisconnectionSiteDetailsMeter: React.FC<Props> = ({
  idPrefix,
  index,
  meter,
}) => {
  return (
    <>
      <Span
        display="inline-block"
        fontSize={4}
        lineHeight={4}
        fontWeight="medium"
        mt={index === 0 ? 0 : 3}
      >
        Meter {index + 1}
      </Span>
      <MeterDividerLine />
      <Flex flexDirection="column">
        <LabelValuePair
          label="Location of meter"
          value={meter.location}
          id={`${idPrefix}-location-${index}`}
        />
      </Flex>
      <Flex flexDirection="column" mt={3}>
        <LabelValuePair
          label="Meter serial number"
          value={meter.serialNumber ? meter.serialNumber : "Unknown"}
          id={`${idPrefix}-serial-${index}`}
        />
      </Flex>
    </>
  );
};
